import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AlertService } from 'app/core/util/alert.service';

@Injectable()
export class NotificationInterceptor implements HttpInterceptor {
  private alertService = inject(AlertService);

  // intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   return next.handle(request).pipe(
  //     tap((event: HttpEvent<any>) => {
  //       if (event instanceof HttpResponse) {
  //         let alert: string | null = null;

  //         for (const headerKey of event.headers.keys()) {
  //           if (headerKey.toLowerCase().endsWith('app-alert')) {
  //             alert = event.headers.get(headerKey);
  //           }
  //         }

  //         if (alert) {
  //           this.alertService.addAlert({
  //             type: 'success',
  //             message: alert,
  //           });
  //         }
  //       }
  //     }),
  //   );
  // }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        // Bỏ qua xử lý alert cho các request không cần thông báo
        if (
          event instanceof HttpResponse &&
          event.headers.get('X-parkingTicketManagementApp-alert')
        ) {
          // Không làm gì cả để bỏ qua thông báo
          // Hoặc có thể thêm điều kiện để chỉ hiển thị một số thông báo nhất định
          event.headers.delete('X-parkingTicketManagementApp-alert');
        }
      })
    );
  }
}
